import React from "react";
import Header from "./Components/Header";
import Body from "./Components/Body";

const App: React.FC = () => {
  return (
    <div>
      <Header />
      <Body />
    </div>
  );
};

export default App;
